import { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchServices = (reloadTrigger) => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshNonce, setRefreshNonce] = useState(0);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    const refetch = useCallback(() => {
        setRefreshNonce((current) => current + 1);
    }, []);

    useEffect(() => {
        let cancelled = false;

        const fetchServices = async () => {
            setLoading(true);
            setError(null);

            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/services`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`Service listing request failed with status ${response.status}`);
                }

                const data = await response.json();
                if (!Array.isArray(data)) {
                    throw new Error('Service listings response was empty or malformed.');
                }
                if (!cancelled) {
                    setServices(data);
                }
            } catch (error) {
                console.error('Error fetching services:', error.message);
                if (!cancelled) {
                    setError('Could not load service listings. Please retry.');
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        fetchServices();

        return () => {
            cancelled = true;
        };
    }, [getAccessTokenSilently, apiUrl, reloadTrigger, refreshNonce]);

    return { services, loading, error, refetch };
};

export default useFetchServices;
